(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["impact-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const targets = document.querySelectorAll('.count-up-target[data-count]');

    const countUp = (el) => {
      const originalText = el.dataset.count.trim();
      const numericPart = parseFloat(originalText.replace(/[^0-9.]/g, ''));
      const suffix = originalText.replace(/[0-9.,]/g, '').trim(); // This will capture "+" or "k+" or similar

      const duration = parseFloat(el.dataset.duration) * 1000 || 1000;
      const startTime = performance.now();

      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const value = Math.floor(progress * numericPart);
        el.innerText = value.toLocaleString();

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          el.innerText = numericPart.toLocaleString() + suffix;
        }
      };

      requestAnimationFrame(update);
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            if (!el.classList.contains('counted')) {
              countUp(el);
              el.classList.add('counted');
            }
            obs.unobserve(el);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    targets.forEach((el) => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
